import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Button, Form, Modal, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PERMISSIONS, getPremiumStatus } from '../../../util/permissions';
import { trackPriceQuoteRequest } from '../../../util/mixpanel';

import { error, inviteUser, updateUser } from '../UsersActions';
import { activatePremium } from '../../ReportConfig/ReportActions';
import CheckBox from '../../../components/Checkbox/Checkbox';
import Switch from '../../../components/Switch/Switch';
import { INTEGRATIONS } from '../../../util/integrations';

import mailIcon from '../../../assets/img/mail.svg';
import saveIcon from '../../../assets/img/save.svg';

import './AddUser.scss';

const defaultState = {
  email: '',
  manageBilling: false,
  manageUsers: false,
  createDashboards: false,
  createStreams: false,
  createPortfolios: false,
  dashboards: [],
  streams: [],
  portfolios: [],
  selectedTab: 'dashboards',
  search: '',
  model: {}
};

export class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      isOpened: props.visible
    };
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      const model = { ...this.props.model };
      if (this.props.model) {
        _.forEach(['dashboards', 'streams', 'portfolios'], (entity) => {
          if (this.props.model[entity]) {
            const permission = {};
            _.forEach(this.props.model[entity], e => {
              permission[e[PERMISSIONS[entity].entityId]] = {
                view: e.view,
                edit: e.edit,
                delete: e.delete
              };
            });
            model[entity] = permission;
          }

          this.checkIfAllSelected(model, entity, 'view');
          this.checkIfAllSelected(model, entity, 'edit');
          this.checkIfAllSelected(model, entity, 'delete');
        });
      }

      this.setState({
        ...defaultState,
        isOpened: true,
        dashboards: this.props.dashboards,
        streams: this.props.streams,
        portfolios: this.props.portfolios,
        model: model || {}
      });
    }
  };

  onClose = (event, propagate) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      isOpened: false
    });

    !!this.props.onClose && !!propagate && this.props.onClose();
  };

  onSearch = e => {
    const search = e.target.value;
    const dashboards = _.filter(this.props.dashboards, d => {
      return d.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });

    this.setState({ dashboards, search });
  };

  checkIfAllSelected = (model, entity, name) => {
    const count = _.filter(model[entity], e => {
      return !!e[name];
    }).length;

    this.setState({ [`${entity}-${name}All`]: count === this.props[entity].length });
  };

  handleGlobalPermissionsCheck = e => {
    const model = this.state.model;
    model[e.name] = e.checked;
    this.setState({ model });
  };

  handleAllChecked = e => {
    const { model, selectedTab } = this.state;
    const { entityName } = PERMISSIONS[selectedTab];

    const name = e.name.substring(0, e.name.indexOf('All'));
    _.forEach(this.state[entityName], item => {
      if (!e.checked) {
        delete model[entityName][item._id][name];
      } else {
        if (!model[entityName]) {
          model[entityName] = {};
        }
        if (!model[entityName][item._id]) {
          model[entityName][item._id] = {};
        }

        model[entityName][item._id][name] = true;
      }
    });

    this.setState({
      model,
      [`${entityName}-${e.name}`]: e.checked
    });
  };

  handleCheck = (e, id) => {
    const { model, selectedTab } = this.state;
    const { entityName } = PERMISSIONS[selectedTab];

    if (!e.checked) {
      delete model[entityName][id][e.name];
    } else {
      if (!model[entityName]) {
        model[entityName] = {};
      }
      if (!model[entityName][id]) {
        model[entityName][id] = {};
      }

      model[entityName][id][e.name] = true;
    }

    this.checkIfAllSelected(model, entityName, e.name);
    this.setState({ model });
  };

  isChecked = (id, name) => {
    const { model, selectedTab } = this.state;
    const { entityName } = PERMISSIONS[selectedTab];
    if (!model[entityName] || !model[entityName][id]) {
      return false;
    }
    const entity = model[entityName][id];
    if (name === 'view') {
      return !!entity['view'] || !!entity['edit'] || !!entity['delete'];
    }

    return !!entity[name];
  };

  isDisabled = (id, name) => {
    const { permissions } = this.props;
    const { selectedTab } = this.state;
    const { full, view, entityName, entityId } = PERMISSIONS[selectedTab];

    if (permissions[full] || permissions[view]) {
      return !(name === 'view' || (permissions[full]));
    } else {
      if (id) {
        const entity = _.find(permissions[entityName], { [entityId]: id });
        if (entity) {
          return !entity[name] || (
            name === 'view' && (
              this.isChecked(id, 'edit') && this.isDisabled(id, 'edit') ||
              this.isChecked(id, 'delete') && this.isDisabled(id, 'delete')
            ))
        }
      } else {
        return _.some(this.props[entityName], e => {
          const entity = _.find(permissions[entityName], { [entityId]: e._id });
          if (entity) {
            return !entity[name] || (
              name === 'view' && (
                this.isChecked(e._id, 'edit') && this.isDisabled(e._id, 'edit') ||
                this.isChecked(e._id, 'delete') && this.isDisabled(e._id, 'delete')
              ))
          }
        })
      }
    }
    return true; 
  }

  formatModel = () => {
    const model = { ...this.state.model, users: this.props.users };
    _.forEach(['dashboards', 'streams', 'portfolios'], entity => {
      const { entityId } = PERMISSIONS[entity];
      model[entity] = _(this.state.model[entity]).map((value, id) => ({[entityId]: id, ...value})).value();
    });

    return model;
  };

  hasPermissions = () => {
    const hasDashboardsAccess = _.some(this.state.model.dashboards, d => d.view || d.edit || d.delete);
    const hasStreamsAccess = _.some(this.state.model.streams, d => d.view || d.edit || d.delete);
    const hasPortfoliosAccess = _.some(this.state.model.portfolios, d => d.view || d.edit || d.delete);
    return (
      this.state.model.createDashboards ||
      this.state.model.createStreams ||
      this.state.model.createPortfolios ||
      this.state.model.manageBilling ||
      this.state.model.manageUsers ||
      this.state.model.manageDashboards ||
      this.state.model.manageDashboardsViewOnly ||
      this.state.model.manageStreams ||
      this.state.model.manageStreamsViewOnly ||
      this.state.model.managePortfolios ||
      this.state.model.managePortfoliosViewOnly ||
      hasDashboardsAccess || hasStreamsAccess || hasPortfoliosAccess
    );
  };

  handleSendInvitation = () => {
    if (!this.state.model.email) {
      this.props.setError('Email is required');
      return false;
    }
    if (!this.hasPermissions()) {
      this.props.setError("You haven't selected any access rights");
      return false;
    }

    const model = this.formatModel();
    if (model.email) {
      model.email = _(model.email.split(','))
        .map(email => email.trim())
        .filter(email => !!email)
        .value();
    }

    this.props.sendInvitation(model);
    this.onClose();
  };

  handleUpdate = () => {
    if (!this.hasPermissions()) {
      this.props.setError("You haven't selected any access rights");
      return false;
    }
    if (this.props.bulk) {
      this.props.bulkUpdateUsers(this.formatModel());
    } else {
      this.props.updateUser(this.formatModel());
    }

    this.onClose();
  };

  handlePermissionToggle = ({name, checked}) => {
    if (name) {
      this.setState({
        model: {
          ...this.state.model,
          [name]: checked,
        }
      });
    }
  };

  handleTabClick = (e) => {
    if (e && e.target && e.target.id) {
      this.setState({ selectedTab: e.target.id});
    }
  };

  renderTab(premiumStatus) {
    const { permissions } = this.props;
    const { selectedTab } = this.state;

    const { full, view, create } = PERMISSIONS[selectedTab];

    if (selectedTab !== 'dashboards' && premiumStatus !== 'active') {
      return premiumStatus === 'inactive' ? this.renderActivatePremium() : this.renderPremiumExpired(premiumStatus);
    }

    return (
      <div className="tab-group">
        <div className="flex-group togglers">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="create-permission-tooltip" className="tooltip_white">
                Only users who can create {PERMISSIONS[selectedTab].label.toLowerCase()} can grant this permission. You don't currently have that access
              </Tooltip>
            }
            delay={{ show: 250, hide: 400 }}
            trigger={permissions[create] ? [] : ['hover', 'focus']}
          >
            <span style={!permissions[create] ? { opacity: 0.5 } : undefined}>
              <Switch
                id={create}
                className="switch_box_right_label"
                name={create}
                label="Create"
                checked={!!this.state.model[create]}
                disabled={!permissions[create]}
                onChange={this.handlePermissionToggle}
              />
            </span>
          </OverlayTrigger>
          {(permissions[view] || permissions[full]) && <Switch
            id={view}
            className="switch_box_right_label"
            name={view}
            label="View all"
            checked={this.state.model[view] || this.state.model[full]}
            disabled={!!this.state.model[full] || (!permissions[full] && !permissions[view])}
            onChange={this.handlePermissionToggle}
          />}
          { permissions[full] && <Switch
            id={full}
            className="switch_box_right_label"
            name={full}
            label="Full access to all"
            checked={this.state.model[full]}
            disabled={!permissions[full]}
            onChange={this.handlePermissionToggle}
          />}
          { (permissions[view] || permissions[full]) && (
            <div className="reminder">
              <div className="info">i</div><span>{PERMISSIONS[selectedTab].reminder}</span> 
            </div>
          )}
        </div>
        {!this.state.model[view] && !this.state.model[full] && (
          <React.Fragment>
            <div className="table-search">
              <div className='search-wrap'>
                <input
                  name="search"
                  placeholder="Search"
                  type="text"
                  id="Search"
                  className="form-control"
                  value={this.state.search}
                  onChange={this.onSearch}
                />
              </div>
            </div>
            
            <div className="table-scroll">
              <Table>
                <thead>
                  <tr>
                    <th>
                      Name
                    </th>
                    <th>
                      <CheckBox
                        id="viewAll"
                        name="viewAll"
                        label="View"
                        disabled={this.isDisabled(undefined, 'view')}
                        checked={this.state[`${selectedTab}-viewAll`]}
                        onChange={this.handleAllChecked}
                      />
                    </th>
                    <th>
                      <CheckBox
                        id="editAll"
                        name="editAll"
                        label="Edit"
                        disabled={this.isDisabled(undefined, 'edit')}
                        checked={this.state[`${selectedTab}-editAll`]}
                        onChange={this.handleAllChecked}
                      />
                    </th>
                    <th>
                      <CheckBox
                        id="deleteAll"
                        name="deleteAll"
                        label="Delete"
                        disabled={this.isDisabled(undefined, 'delete')}
                        checked={this.state[`${selectedTab}-deleteAll`]}
                        onChange={this.handleAllChecked}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state[selectedTab].map((d, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          {d.application ? (
                            <span className="integration_link">
                              <img className="connection_icon" src={INTEGRATIONS[d.application].icon} alt="#"/>
                            </span>
                          ) : null}
                          {d.label || d.name}</td>
                        <td>
                          <CheckBox
                            id="view"
                            name="view"
                            label="View"
                            disabled={this.isDisabled(d._id, 'view')}
                            checked={this.isChecked(d._id, 'view')}
                            onChange={e => this.handleCheck(e, d._id)}
                          />
                        </td>
                        <td>
                          <CheckBox
                            id="edit"
                            name="edit"
                            label="Edit"
                            disabled={this.isDisabled(d._id, 'edit')}
                            checked={this.isChecked(d._id, 'edit')}
                            onChange={e => this.handleCheck(e, d._id)}
                          />
                        </td>
                        <td>
                          <CheckBox
                            id="delete"
                            name="delete"
                            label="Delete"
                            disabled={this.isDisabled(d._id, 'delete')}
                            checked={this.isChecked(d._id, 'delete')}
                            onChange={e => this.handleCheck(e, d._id)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  {!this.state[selectedTab].length && (
                    <tr>
                      <td style={{ textAlign: 'center' }} colspan="4">
                        {PERMISSIONS[selectedTab].emptyLabel}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }

  trackPriceQuoteRequest() {
    trackPriceQuoteRequest();
  }

  handleActivateClick = () => {
    this.props.activate('/users');
  }

  renderActivatePremium() {
    return (
      <div className="banner">
        <div className="message">Value streams and Portfolios are not included in your current plan. <a href="/premium">Learn More</a></div>
        <div
          className="btn btn-red"
          onClick={this.handleActivateClick}
        >
          Try Nave Premium for 30 days
        </div>
      </div>
    )
  }

  renderPremiumExpired(premiumStatus) {
    const message = premiumStatus === 'deactivated'    
       ? 'Your Premium subscription has ended':
       'Your Premium trial has ended';
    return (
      <div className="banner">
        <div className="message">{message}</div>
        <a href="mailto:hello@getnave.com"
          className='btn btn-red'
          onClick={this.trackPriceQuoteRequest}
          onAuxClick={this.trackPriceQuoteRequest}
        >
          Request Pricing Quote
        </a>
      </div>
    )
  }

  render() {
    const { permissions, user } = this.props;
    const manageBilling = permissions.manageBilling;
    const manageUsers = permissions.manageUsers;
    
    const premiumStatus = getPremiumStatus(user);
    const { dashboards, streams, portfolios } = this.state;
    const totalDashboards = dashboards && dashboards.length || 0;
    const totalStreams = streams && streams.length || 0;
    const totalPortfolios = portfolios && portfolios.length || 0;

    const { selectedTab } = this.state;

    var modal = (
      <Modal 
        keyboard={false}
        backdrop='static'
        show={this.state.isOpened}
        onHide={this.onClose}
        className="invite-new-user-modal"
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.bulk
              ? `Grant bulk permissions (${this.props.users.length} users selected)`
              : !this.props.model
              ? 'Invite new user'
              : "Edit user's permissions"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="form_content">
          {!this.props.bulk && (
            <Form>
              <Form.Group>
                <Form.Label htmlFor="email">
                  Email addresses
                </Form.Label>
                <Form.Control
                  disabled={!!this.props.model}
                  placeholder="Additional email addresses must be separated by a comma"
                  type="textarea"
                  rows="1"
                  name="email"
                  value={this.state.model.email}
                  onChange={e => {
                    e.target.style.overflow = 'hidden';
                    e.target.style.height = 0;
                    e.target.style.height = e.target.scrollHeight + 'px';
                    this.setState({
                      model: {
                        ...this.state.model,
                        email: e.target.value
                      }
                    });
                  }}
                />
              </Form.Group>
            </Form>
          )}

          <div className="box-group">
            <label className="form-label">General permissions</label>
            <div className="flex-group togglers">
              {manageBilling && (
                <Switch
                  id="manageBilling"
                  className="switch_box_right_label"
                  name="manageBilling"
                  label="Manage Billing"
                  checked={this.state.model.manageBilling}
                  onChange={this.handleGlobalPermissionsCheck}
                />
              )}
              {manageUsers && (
                <Switch
                  id="manageUsers"
                  className="switch_box_right_label"
                  name="manageUsers"
                  label="Manage Users"
                  checked={this.state.model.manageUsers}
                  onChange={this.handleGlobalPermissionsCheck}
                />
              )}
            </div>
          </div>
          <div className="box-group">
            <label className="form-label">Dashboards and Views permissions</label>
            <div className="tab-menu">
              <div id="dashboards" className={`tab-label${selectedTab === "dashboards" ? " selected" : ""}`} onClick={this.handleTabClick}>
                Team Dashboards ({totalDashboards})
              </div>
              <div id="streams" className={`tab-label${selectedTab === "streams" ? " selected" : ""}`} onClick={this.handleTabClick}>
                Value Streams {premiumStatus === 'active' ? `(${totalStreams})` : <span className="info">?</span>}
              </div>
              <div id="portfolios" className={`tab-label${selectedTab === "portfolios" ? " selected" : ""}`} onClick={this.handleTabClick}>
                Portfolios {premiumStatus === 'active' ? `(${totalPortfolios})` : <span className="info">?</span>}
              </div>
            </div>
            {this.renderTab(premiumStatus)}
          </div>
        </Modal.Body>
        <Modal.Footer>
          
          {!this.props.bulk && !this.props.model ? (
            <Button variant='primary' onClick={this.handleSendInvitation}>
              <img src={mailIcon} alt="" />
              Send invitation
            </Button>
          ) : (
            <Button variant='primary' onClick={this.handleUpdate}>
              <img src={saveIcon} alt="" />
              {this.props.bulk ? 'Bulk Update' : 'Update'}
            </Button>
          )}
          <Button variant='secondary' onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...btn.props,
          onClick: this.onButtonClick
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

AddUser.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  model: PropTypes.object
};

AddUser.defaultProps = {
  visible: false
};

const mapDispatchToProps = dispatch => {
  return {
    sendInvitation: model => dispatch(inviteUser(model)),
    updateUser: model => dispatch(updateUser(model)),
    bulkUpdateUsers: model => dispatch(updateUser(model, true)),
    activate: from => dispatch(activatePremium(from)),
    setError: err => dispatch(error(err))
  };
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    streams: state.report.streams,
    portfolios: state.portfolio.portfolios,
    dashboards: state.dashboards.list,
    permissions: state.auth.user.permissions,
    manageBilling: !!state.auth.user.permissions && !!state.auth.user.permissions.manageBilling
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
